<div class="loading-block" [hidden]="!showSpinner">
  <pos-spinner-icon></pos-spinner-icon>
</div>
